import { motion } from 'framer-motion'
import { CheckCircle, Users, Award, Coffee } from 'react-feather'
import { useCountUp } from '../../hooks/useCountUp'
import './About.css'

export default function About() {
  const stats = [
    { icon: Users, value: 10, label: 'Happy Clients' },
    { icon: Award, value: 20, label: 'Projects Completed' },
    { icon: Coffee, value: 100, label: 'Coffee Cups' },
  ]

  // Create separate counters for each stat
  const clientCount = useCountUp(stats[0].value, 2000)
  const projectCount = useCountUp(stats[1].value, 2000)
  const coffeeCount = useCountUp(stats[2].value, 2000)
  
  const counters = [clientCount, projectCount, coffeeCount]

  const features = [
    'Custom Software Development',
    'Mobile App Development',
    'Web Application Development',
    'UI/UX Design',
    'Cloud Solutions',
    'Digital Transformation',
  ]

  return (
    <section className="about-section" id='about'>
      <div className="about-container">
        <motion.div 
          className="about-content"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div className="about-text">
            <motion.h2 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              Crafting Digital Excellence with 
              <span className="gradient-text"> Innovation</span>
            </motion.h2>
            
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="about-description"
            >
              At evoaxy Solutions, we're more than just a software company. We're your technology partner, 
              committed to transforming your ideas into powerful digital solutions. Our team of experts 
              combines creativity with technical expertise to deliver exceptional results that drive your 
              business forward.
            </motion.p>

            <motion.div 
              className="features-grid"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.4 }}
            >
              {features.map((feature, index) => (
                <div key={index} className="feature-item">
                  <CheckCircle className="feature-icon" />
                  <span>{feature}</span>
                </div>
              ))}
            </motion.div>
          </div>

          <motion.div 
            className="stats-container"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            {stats.map((stat, index) => {
              const Icon = stat.icon
              return (
                <motion.div 
                  key={index}
                  className="stat-card"
                  whileHover={{ scale: 1.05 }}
                  transition={{ type: "spring", stiffness: 300 }}
                >
                  <Icon className="stat-icon" />
                  <h3>{counters[index]}+</h3>
                  <p>{stat.label}</p>
                </motion.div>
              )
            })}
          </motion.div>
        </motion.div>
      </div>
    </section>
  )
}

